/**
 * Focus Selector
 * Simple dropdown for category selection with clear labeling
 */

import React from 'react';
import { Target } from 'lucide-react';

const FocusSelector = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    { value: 'all', label: 'Everything feels overwhelming', emoji: '🌊' },
    { value: 'essays', label: 'Essays & Writing', emoji: '📝' },
    { value: 'research', label: 'College Research', emoji: '🔍' },
    { value: 'testing', label: 'Testing Strategy', emoji: '📊' },
    { value: 'applications', label: 'Applications', emoji: '📋' },
    { value: 'financial', label: 'Financial Aid', emoji: '💰' }
  ];

  return (
    <div className="space-y-2">
      <label className="flex items-center gap-2 text-sm font-semibold text-slate-900">
        <Target className="w-4 h-4" />
        What needs attention?
      </label>
      <select
        value={selectedCategory}
        onChange={(e) => onCategoryChange(e.target.value)}
        className="w-full px-4 py-3 bg-white border-2 border-slate-300 rounded-lg text-sm font-medium text-slate-900 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-colors cursor-pointer"
      >
        {categories.map(cat => (
          <option key={cat.value} value={cat.value}>
            {cat.emoji} {cat.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FocusSelector;
